import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  Collapse,
  InputGroup,
  InputGroupAddon,
  Col,
  Row,
} from 'reactstrap';
import { EmailShareButton } from 'react-share';
import { toast } from 'react-toastify';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap4-modal';
import ToggleButton from 'react-toggle-button';
import SurveyApi from 'apis/Survey';
import copyToClipboard from 'utils/copyToClipboard';

class ReportShareModal extends Component {
  constructor() {
    super();

    this.state = {
      checkvalue: null,
      togglePasswordField: false,
      password: '',
      isPasswordVisible: false,
      error: null,
      copySucceed: false,
    };
  }

  modalBackdropClicked = () => {
    this.props.toggle();
  };

  displayAndHideCopyText = () => {
    var that = this;
    this.setState({ copySucceed: true });
    setTimeout(() => {
      that.setState({ copySucceed: false });
    }, 5000);
  };

  toggle = () => {
    const { togglePasswordField } = this.state;
    this.setState({ togglePasswordField: !togglePasswordField });
  };

  componentDidUpdate(prevProps) {
    const { customSurveyId } = this.props;
    if (customSurveyId !== prevProps.customSurveyId) {
      this.isReportProtected();
    }
  }

  handleCopyText = (url) => {
    copyToClipboard(url);
    this.displayAndHideCopyText();
  };

  getPassword = () => {
    const { customSurveyId } = this.props;
    SurveyApi.getPassword(customSurveyId).then(({ data }) => {
      this.setState({ password: data });
    });
  };

  togglePasswordText = () => {
    this.setState((prevState) => ({ isPasswordVisible: !prevState.isPasswordVisible }))
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
      error: null,
    });
  };

  generateBodyText = imgurl => {
    return `${imgurl}\n\n\n`;
  };

  isReportProtected = () => {
    const { customSurveyId } = this.props;
    SurveyApi.verifyReportPassword(customSurveyId, 'Pass Presence').then(({ data }) => {
      if (data) {
        this.setState({ checkvalue: data, isPasswordVisible: false });
        this.getPassword();
      } else {
        this.setState({ checkvalue: false, password: '' });
      }
    });
  }

  getSurveyName = () => {
    const { customSurveyId } = this.props;
    const { customSurvey } = this.state;

    if (customSurvey == null) {
      SurveyApi.getSurveyName(customSurveyId).then(({ data }) => {
        this.setState({
          customSurvey: data,
        });
      });
      this.isReportProtected();
    }
    return customSurvey;
  };

  validatePassword = () => {
    const { password } = this.state;

    return (password.length < 4 ||
      password.length > 12);
  }

  savePassword = e => {
    const { customSurveyId } = this.props;
    const { password, togglePasswordField, checkvalue } = this.state;
    const isInValidPassword = this.validatePassword();
    if (isInValidPassword) {
      this.setState({ error: "Value should be between 4 to 12 charaters" });
      return;
    }
    e.preventDefault();
    SurveyApi.saveSurveyReportPassword(customSurveyId, checkvalue, password).then(({ data }) => {
      this.setState({
        togglePasswordField: !togglePasswordField,
      });
      toast.success(() => (
        <div>
          <FontAwesomeIcon icon="check-circle" />
          Password Saved successfully
        </div>
      ));
    });
  };

  savePasswordBit = () => {
    const { customSurveyId } = this.props;
    const { checkvalue } = this.state;
    if (checkvalue) {
      SurveyApi.saveSurveyReportPassword(customSurveyId, !checkvalue).then(({ data }) => { console.log(data) });
    }
    this.setState({ checkvalue: !checkvalue });
  };

  render() {
    const { id, customSurveyId, modalToggle, toggle } = this.props;
    const { copySucceed, checkvalue, password, isPasswordVisible, error } = this.state;

    const shareUrl = `${process.env.REACT_APP_DASHBOARD_URL}/businesses/${id}/custom_surveys/${customSurveyId}/surveyreports`;
    const inputType = isPasswordVisible ? 'text' : 'password';

    return (
      <Modal visible={modalToggle} onClickBackdrop={this.modalBackdropClicked}>
        <div className="modal-header">
          <h5 className="modal-title">Share Report</h5>
          <span onClick={toggle} className="cursor-pointer close-delete-popup">
            X
          </span>
        </div>
        <div className="modal-body">
          <Row>
            <Col md={{ size: 12 }} className="col-top">
              <InputGroup size="sm" className="pl-1 mr-1 report-share-modal-input-group">
                <EmailShareButton
                  body={this.generateBodyText(shareUrl)}
                  subject={this.getSurveyName()}
                >
                  <FontAwesomeIcon icon="envelope" className="report-share-email-icon" />
                </EmailShareButton>
                <InputGroupAddon
                  addonType="prepend"
                  className="mt-1 ml-1 mb-0 pr-0 report-share-import-group"
                  onClick={() => this.handleCopyText(shareUrl)}
                  data-toggle="tooltip"
                  title="Copy to clipboard"
                >
                  <FontAwesomeIcon icon="cut" className="font-awesome-font" />
                </InputGroupAddon>
                <a
                  target="_blank"
                  className="report-share-link"
                  href={shareUrl}
                >
                  <Input
                    className="ml-0 pl-0 re report-share-input-field"
                    defaultValue={shareUrl}
                  />
                </a>
              </InputGroup>
              <span className="report-share-text-copied">{copySucceed ? 'Copied!' : ''}</span>
            </Col>
          </Row>
          <Row>
            <Col md={{ size: 10 }} className="report-share-password-col">
              <label> Password protect this link: </label>
            </Col>
            <Col md={{ size: 1 }} className="password-column">
              <ToggleButton
                inactiveLabel={'No'}
                activeLabel={'Yes'}
                value={checkvalue || ''}
                onToggle={this.savePasswordBit}
              />
            </Col>
          </Row>
          <Collapse isOpen={checkvalue}>
            <Col md={{ size: 12 }} className="col-password-input">
              <div className="report-share-password-div">
                <form autocomplete="off">
                  <Input
                    type={inputType}
                    name="password"
                    placeholder="Enter the password"
                    onChange={this.onChange}
                    required={true}
                    value={password}
                  />
                </form>
                {error && (<div className="row error" id="passwordError" >{error}</div>)}
              </div>
              <Button
                onClick={this.togglePasswordText}
                title="show/hide password"
                className="report-share-modal-button report-share-password-show-hide"
                color="blue"
              >
                <FontAwesomeIcon icon="eye" className="report-share-password-show-hide-icon" />
              </Button>
              <Button
                onClick={e => this.savePassword(e)}
                className="report-share-modal-button report-share-password-save"
                color=""
              >
                Save
                </Button>
            </Col>
          </Collapse>
        </div>
      </Modal>
    );
  }
}

ReportShareModal.propTypes = {
  toggle: PropTypes.func,
  customSurveyId: PropTypes.string,
  modalToggle: PropTypes.bool,
  id: PropTypes.string
};

export default ReportShareModal;


// WEBPACK FOOTER //
// ./src/components/reports/ReportShareModal.js